import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field } from "@/components/ui-helpers";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export function ProfileDialog({ open, onOpenChange }) {
  const { user, updateUser } = useAuth();
  const [name, setName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open && user) { setName(user.name || ""); setDisplayName(user.display_name || ""); }
  }, [open, user]);

  const save = async () => {
    if (!name.trim()) return toast.error("Nama lengkap tidak boleh kosong");
    setBusy(true);
    try {
      const r = await api.put("/auth/profile", { name: name.trim(), display_name: displayName.trim() });
      updateUser({ ...user, ...r.data });
      toast.success("Profil berhasil diperbarui");
      onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal memperbarui profil"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Pengaturan Profil</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Field label="Nama Lengkap" required>
            <Input value={name} onChange={(e) => setName(e.target.value)} data-testid="profile-name" placeholder="Nama lengkap" />
          </Field>
          <Field label="Nama Tampilan" hint="Nama yang tampil di menu & sapaan dashboard. Kosongkan untuk pakai nama lengkap.">
            <Input value={displayName} onChange={(e) => setDisplayName(e.target.value)} data-testid="profile-display-name" placeholder="Nama tampilan" />
          </Field>
          <div className="rounded-lg bg-secondary/40 p-3 text-xs text-muted-foreground space-y-0.5">
            <p><b>Email:</b> {user?.email}</p>
            <p><b>Peran:</b> <span className="capitalize">{user?.role}</span></p>
            <p>Email, password, dan peran tidak diubah di sini.</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="profile-cancel">Batal</Button>
          <Button onClick={save} disabled={busy} data-testid="profile-save">{busy ? "Menyimpan..." : "Simpan Perubahan"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
